<template>
    <div>
        <div class="box-input-width relative mt-5 px-3 m-auto">
            <label for="input-pass">
                <div class="grid grid-cols-6 gap-2 text-center text-24 font-bold text-a-brown-502314">
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[0] ? '*': ''}}</div>
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[1] ? '*': ''}}</div>
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[2] ? '*': ''}}</div>
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[3] ? '*': ''}}</div>
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[4] ? '*': ''}}</div>
                    <div class="bg-white border py-2 h-12 rounded-10">{{content[5] ? '*': ''}}</div>
                </div>
            </label>
            <input type="tel" id="input-pass" ref="input-pass" class="input-6" maxlength="6" v-model="content" @input="onInputChange()" @keyup.enter="onEnter()">
        </div>
    </div>
</template>
<script>
import RegxHelper from '@/helper/RegxHelper';

export default {
    props: {
        inputValue: { type: String, default: '' },
    },
    data: function () {
        return {
            content: '',
        };
    },
    created: function () {
        this.content = this.inputValue;
    },
    methods: {
        onInputChange: function () {
            this.content = RegxHelper.removeNotNumber(this.content);
            this.$emit('update:inputValue', this.content);
        },
        onEnter: function () {
            this.$emit('onEnter');
        },
        clearInput: function () {
            this.content = '';
            this.onInputChange();
        },
        focus: function() {
            this.$refs['input-pass'].focus();
        }
    },
}
</script>
<style lang="scss" scoped>
    .box-input-width {
        max-width: 290px;
    }
    .input-6 {
        opacity: 0;
        position: absolute;
        top: -20000px;
        left: -20000px;
    }
</style>
